// extracted by mini-css-extract-plugin
module.exports = {"form":"SelectInitTemplates_form__sfSJU","field":"SelectInitTemplates_field__3eewe"};